<div class="lum-modal client-profile-dialog__modal-wrapper">
  <div class="lum-modal__header justify-space-between w-p100 mb-6">
    <span class="lum-modal__header-title flex text-large">Contact Details</span>
  </div>
</div>

<form [formGroup]="form" class="profile-address__wrapper" (submit)="onSubmit()">
  <div class="lum-modal__body">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="lum-label">Contact Name</label>
          <input type="text" class="lum-input" formControlName="contactName" />
          <mat-error *ngIf="contactNameControl && contactNameControl.invalid">{{
            contactNameControl | validateField
          }}</mat-error>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="lum-label">Contact Email</label>
          <input type="text" class="lum-input" formControlName="contactEmail" />
          <mat-error *ngIf="contactEmailControl && contactEmailControl.invalid">{{
            contactEmailControl | validateField
          }}</mat-error>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="lum-label">Contact Phone</label>
          <input type="text" class="lum-input" formControlName="contactPhone" />
          <mat-error *ngIf="contactPhoneControl && contactPhoneControl.invalid">{{
            contactPhoneControl | validateField
          }}</mat-error>
        </div>
      </div>
    </div>
    <hr />
    <div class="lum-modal__footer">
      <div class="d-flex justify-content-end lum-modal__action">
        <button
          type="button"
          class="lum-button lum-button--secondary mr-2"
          mat-button
          (click)="onClose()"
        >
          Close
          <lum-ui-icon
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
        </button>

        <lum-ui-button
          [disabled]="form.invalid || loading || false"
          [loading]="loading"
          (clickEvent)="onSubmit()"
        >
          Save
          <lum-ui-icon
            class="ml-2-5"
            icon="content-save"
            color="#ffffff"
            width="23"
            height="23"
          ></lum-ui-icon>
        </lum-ui-button>
      </div>
    </div>
  </div>
</form>
